module.exports = __webpack_public_path__ + "static/media/stumpedbanner.8346f24a.png";